class BackStorage {
  backHistoryKey: string;

  backHistoryState: string;

  historyBoundaryReloadKey: string;

  constructor() {
    this.backHistoryKey = '_backHistoryStateInitialPath';
    this.backHistoryState = '_backHistoryState';
    this.historyBoundaryReloadKey = '_historyBoundaryReload';
  }

  setHistoryBoundaryReload() {
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(this.historyBoundaryReloadKey, '1');
    }
  }

  consumeHistoryBoundaryReload(): boolean {
    if (typeof window === 'undefined') return false;

    const isHistoryBoundaryReload = !!window.sessionStorage.getItem(
      this.historyBoundaryReloadKey
    );
    window.sessionStorage.removeItem(this.historyBoundaryReloadKey);

    return isHistoryBoundaryReload;
  }

  setBackHistoryStorageInitialPath(path: string) {
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(this.backHistoryKey, path);
    }
  }

  getBackHistoryStorageInitialPath() {
    if (typeof window !== 'undefined') {
      return window.sessionStorage.getItem(this.backHistoryKey);
    }
  }

  setBackHistoryStorage() {
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(this.backHistoryState, '0');
    }
  }

  getBackHistoryStorage() {
    if (typeof window !== 'undefined') {
      return window.sessionStorage.getItem(this.backHistoryState);
    }
  }

  removeBackHistoryStorage() {
    if (typeof window !== 'undefined') {
      window.sessionStorage.removeItem(this.backHistoryState);
      window.sessionStorage.removeItem(this.backHistoryKey);
    }
  }
}

export const BackHistoryStorage = new BackStorage();
